import React from 'react';
import Breadcrumb from '../../../../core/layout/Breadcrumb';
import Tabs from '../../../../core/layout/Tabs';
import Card from '../../../../core/layout/Card';
import CustomerSuccessGlobalTab from './CustomerSuccessGlobalTab';
import CustomerSuccessSegmentTab from './CustomerSuccessSegmentTab';
import CustomerSuccessDistributorTab from './CustomerSuccessDistributorTab';
import Separator from '../../../../core/layout/Separator';
import KpiReferenceMonth from '../../commons/KpiReferenceMonth';

const CustomerSuccessScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'KPIs Customer Success',
        },
      ]}
    />
    <Card key="card">
      <KpiReferenceMonth />
    </Card>
    <Separator />
    <Tabs
      tabs={[
        {
          title: 'Global',
          key: 'global',
          content: <CustomerSuccessGlobalTab />,
        },
        {
          title: 'Segment',
          key: 'segmento',
          content: <CustomerSuccessSegmentTab />,
        },
        {
          title: 'Distributor',
          key: 'distribuidor',
          content: <CustomerSuccessDistributorTab />,
        },
      ]}
    />
  </div>
);

export default CustomerSuccessScene;
